export const FETCH_DATA_INTERVAL = 30000;
let timeoutId;

const executeCallback = async callback => {
	try {
		await callback();
	} catch (e) {
		console.error(e);
	}
};

const startPolling = async (callback, interval, isFirstRun) => {
	if (!isFirstRun) {
		await executeCallback(callback);
	}

	clearTimeout(timeoutId);
	timeoutId = setTimeout(() => {
		startPolling(callback, interval, false);
	}, interval);
};

const start = async (callback, interval = FETCH_DATA_INTERVAL) => startPolling(callback, interval, true);

const stop = () => {
	clearTimeout(timeoutId);
	timeoutId = undefined;
};

const force = async callback => {
	stop();
	await executeCallback(callback);
	start(callback);
};

export const routesMonitoringPolling = {
	start,
	stop,
	force
};
